// extracted by mini-css-extract-plugin
export default {"button":"style_button__Cai5j","cross":"style_cross__yQG-+"};